"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSecret = void 0;
const CHARACTER_SET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$!%^&*()';
/**
 * Generates a new secret; for rotating keys automatically when deploying.
 * @param length the length of the secret requested
 * @returns the generated secret
 */
function generateSecret(length = 64) {
    let result = '';
    for (let i = 0; i < length; i++) {
        const char = Math.floor(Math.random() * CHARACTER_SET.length + 1);
        result += CHARACTER_SET.charAt(char);
    }
    return result;
}
exports.generateSecret = generateSecret;
//# sourceMappingURL=secret.js.map